import { ObjectReducer, mergeEntity } from '../store';

export const giveGetEligibilityReducer: ObjectReducer<'giveGetEligibility'> = (
  state = {},
  action,
) => {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (
        action.payload &&
        action.payload.ref.path[0] === 'giveGetEligibility'
      ) {
        const { data, ref } = action.payload;
        return mergeEntity<'giveGetEligibility'>(
          state,
          transformGiveGetEligibility(data),
          ref.path,
        );
      }
      return state;
    default:
      return state;
  }
};

export function transformGiveGetEligibility(eligible: boolean) {
  return eligible;
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/give-get/give-get.reducer.ts